import styled from 'styled-components'
import { theme } from '../../styles'

export const ToastsRoot = styled.div`
  position: fixed;
  bottom: 22px;
  right: 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 200;

  ${theme.mobile} {
    right: 16px;
    left: 16px;
    bottom: 24px;
    align-items: stretch;
  }
`

export const ToastItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 340px;
  padding: 13px 17px;
  border-radius: 11px;
  background: ${theme.cores.navy};
  color: ${theme.cores.white};
  font-size: 14px;
  font-weight: 600;
  box-shadow: ${theme.sombras.lg};

  ${theme.mobile} {
    max-width: none;
  }
`

export const ToastIcon = styled.span`
  display: grid;
  place-items: center;
  flex: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${theme.cores.accent};

  svg {
    width: 15px;
    height: 15px;
  }
`

export const ToastMsg = styled.span`
  color: ${theme.cores.white};
`
